<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" class="text-h6 font-weight-bold">শিক্ষাগত যোগ্যতার তালিকা</v-col>
      <v-col cols="6" class="text-end">
        <v-btn color="secondary" size="small" class="me-3 rounded-lg" @click="openModal">
          <v-icon start>mdi-plus-circle-outline</v-icon> যোগ করুন
        </v-btn>
      </v-col>
      <v-col cols="12" md="12">
        <v-table class="language-table">
          <thead>
          <tr>
            <th>কোর্সের নাম</th>
            <th>প্রতিষ্ঠানের নাম</th>
            <th>উত্তীর্ণের বছর</th>
            <th>প্রতিষ্ঠানের ওয়েবসাইটকানা</th>
            <th width="120">অ্যাকশন</th>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td colspan="5" class="text-center py-6">
              কোন তথ্য পাওয়া যায়নি
            </td>
          </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>


    <form>
      <InsertModal ref="Modal" title="সার্টিফিকেট এর তথ্য" :width="900">
        <template #modalBody>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                  label="কোর্সের নাম *"
                  variant="outlined"
                  density="comfortable"
                  placeholder="কোর্সের নাম বাছাই করুন"
                  append-inner-icon="mdi-magnify"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="প্রতিষ্ঠানের নাম (ইংরেজি) *" variant="outlined" density="comfortable"></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="প্রতিষ্ঠানের নাম (বাংলা) *" variant="outlined" density="comfortable"></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-file-input
                  class="flex-grow-1"
                  variant="outlined"
                  rounded="lg"
                  prepend-icon=""
                  hide-details="auto"
                  density="comfortable"
                  label="সার্টিফিকেট আপলোড *"
                  accept=".pdf,.jpg,.jpeg,.png"
                  hint="ফাইলের সর্বোচ্চ সাইজ ৪ মেগাবাইট"
                  persistent-hint
                  prepend-inner-icon="mdi-file"
              ></v-file-input>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="উত্তীর্ণের বছর (ইংরেজি) *" variant="outlined" density="comfortable"></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field label="প্রতিষ্ঠানের ওয়েবঠিকানা" variant="outlined" density="comfortable"></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label class="font-weight-bold">ডিগ্রিটি চাকরিতে যোগদানের পূর্বে অর্জিত কি না?</label>
              <v-radio-group inline hide-details>
                <v-radio label="হ্যাঁ" value="yes"></v-radio>
                <v-radio label="না" value="no"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="6">
              <label class="font-weight-bold">অনলাইন থেকে অর্জিত কি না?</label>
              <v-radio-group inline hide-details>
                <v-radio label="হ্যাঁ" value="yes"></v-radio>
                <v-radio label="না" value="no"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="6">
              <v-menu v-model="cerDate" :close-on-content-click="false" location="bottom">
                <template #activator="{ props }">
                  <v-text-field
                      :model-value="formatDate(form.exp_certificate)"
                      label="সার্টিফিকেট-এর মেয়াদ উত্তীর্ণের তারিখ"
                      prepend-inner-icon="mdi-calendar"
                      variant="outlined"
                      density="comfortable"
                      readonly
                      class="mb-3"
                      v-bind="props"
                  />
                </template>
                <v-date-picker style="margin-top: -20px" v-model="form.exp_certificate" color="primary" hide-header @update:modelValue="cerDate = false"/>
              </v-menu>
            </v-col>
          </v-row>
        </template>
        <template #modalFooter>
          <v-row>
            <v-col cols="12">
              <v-btn color="primary" size="large" class="me-3 rounded-lg" type="submit">
                <v-icon start>mdi-content-save-outline</v-icon>সংরক্ষণ করুন
              </v-btn>
              <v-btn color="grey-darken-1" variant="outlined" size="large" class="rounded-lg" @click="resetForm">
                <v-icon start>mdi-refresh</v-icon>রিসেট
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </InsertModal>
    </form>
  </v-container>
</template>

<script>
import InsertModal from "@/components/shared/InsertModal.vue";

export default {
  name: "ProfessionalCertificate",
  components: {InsertModal},
  data() {
    return {
      cerDate: false,
      form: {
        exp_certificate: ''
      },
    }
  },
  mounted() {},
  methods: {
    openModal() {
      this.$refs.Modal.openModal()
    },
    editItem(item) {
      console.log("Edit:", item);
    },

    submitForm() {
      console.log(this.form);
    },

    resetForm() {
      this.form = {

      };
    },

    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();

      return `${day}-${month}-${year}`;
    },
  },
};
</script>
